//import requestObj from "./request";
let requestObj = {
  upFile: function (options){
    $.ajax({
      url: options.url,
      processData: false,
      contentType: false,
      method: 'post',
      data: options.data,
      success:(res) =>{
        if (options.success) {
          options.success(res);
        }
      },
      error: function (xhr, status, error) {
        if (options.fail) {
          options.fail(xhr, status, error);
        }
        //console.log(xhr, status, error)
      },
      complete: function (xhr, status) {
        if (options.complete) {
          options.complete(xhr, status);
        }
      },
      xhr: function() {
        var xhr = new XMLHttpRequest();
        //使用XMLHttpRequest.upload监听上传过程，注册progress事件，打印回调函数中的event事件
        xhr.upload.addEventListener('progress', function (e) {
          //loaded代表上传了多少
          //total代表总数为多少
          var progressRate = parseInt((e.loaded / e.total) * 100) + '%';

          if(options.progress){
            options.progress(progressRate)
          }
        })

        return xhr;
      }
    });
  }
}
let UploadFile = function(optioins,callback){
    this.options = {
      url: '',
      upName: 'file',
      upSucceessFileUrl: '',
      upSucceessFileId: '',
    }
    this.options = Object.assign(this.options, optioins)
    //console.log('options:', JSON.stringify(this.options))
    this.queue = [];
    this.files = [];
    this.busy = false;
    this.callback = function(){}
    if (callback) {
        this.callback = callback;
    }
    this.upFile = function(file){
        if(file){
            if(Object.prototype.toString.call(file) === '[object Array]'){
                this.queue = this.queue.concat(file);
            }
            else {
                this.queue.push(file);
            }
            this.doUpFile();
        }
    }
    this.doUpFile = function(){
        if(this.busy){
            return
        }
        let queue = this.queue;
        if(queue.length){
            let file = queue.shift();
            let formData = new FormData();
            formData.append(this.options.upName, file.file);
            let temp = {}
            Object.keys(file).forEach(key=>{
                if(key!='file'){
                    temp[key] = file[key];
                }
            })
            file = temp;
            //console.log(file)
            requestObj.upFile({
                url: this.options.url,
                data: formData,
                progress: res => {
                    file.state = 'progress';
                    file.progress = res;
                    this.callback(file);
                },
                success: res => {
                    if(res.state==1){
                      file.state = 'success';
                      /*file.fileUrl = res.data.attachmentName;
                      file.fileId = res.data.attachmentId*/
                      file.fileUrl = res.data[this.options.upSucceessFileUrl];
                      file.fileId = res.data[this.options.upSucceessFileId]
                      this.callback(file);
                    }
                },
                fail: () => {
                    file.state = 'fail';
                    file.fileUrl = '';
                    file.fail = true;
                    this.busy = false;
                    this.callback(file);
                },
                complete: ()=>{
                    this.busy = false;
                    this.doUpFile();
                }
            })
        }
    }
}

export default UploadFile;
